import React from 'react';
import NavbarRedesignForMarketplace from '../Organisms/Header';
import CodeInput from './CodeInput';
import HelmetTag from '../Atoms/HelmetTag';
import { connect } from 'react-redux';
import LocationSelect from './LocationSelect';
import RoomAndTime from './RoomAndTime';
import { setBookingStep, setDataByStep, setLoading } from '../../Actions';
import Summary from './Summary';
import Confirmation from './Confirmation';
import { get, isEmpty } from 'lodash';
import { CircularProgress } from '@mui/material';

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLogin: false,
            isSignin: true,
            width: window.innerWidth,
            currentStep: 0,
            alertType: '',
            alertMessage: '',
        };
        this.showRelevantStep = this.showRelevantStep.bind(this);
        this.setAlertFromChild = this.setAlertFromChild.bind(this);
    }
    setAlertFromChild(alertType, alertMessage) {
        this.setState({
            alertType,
            alertMessage,
        }, () => {
            setTimeout(() => {
                this.setState({
                    alertType: '',
                    alertMessage: '',
                });
            }, 3500);
        })
    }
    showRelevantStep() {
        const { bookingStep } = this.props;
        switch (bookingStep) {
            case 0:
                return <CodeInput setAlert={this.setAlertFromChild} />;
            case 1:
                // NOTE: location step is skipped if code is applied on business level
                return <LocationSelect setAlert={this.setAlertFromChild} />;
            case 2:
                return <RoomAndTime setAlert={this.setAlertFromChild} />;
            case 3:
                return <Summary setAlert={this.setAlertFromChild} />;
            case 4:
                return <Confirmation setAlert={this.setAlertFromChild} />;
            default:
                return null;
        }
    }
    render() {
        const { width, alertType, alertMessage } = this.state;
        const { bookingStep, setBookingStep, setDataByStep, loading } = this.props;

        return (<>
            <div>
                <HelmetTag />

                <NavbarRedesignForMarketplace
                    hideGoBack={bookingStep === 0 || bookingStep === 4}
                    relevantGoBack={() => {
                        let decrementStep = bookingStep - 1;
                        if (bookingStep === 2 && isEmpty(get(this.props, "1.locations", []))) {
                            decrementStep = bookingStep - 2;
                        }
                        //                         if(bookingStep===4) {
                        // setDataByStep()
                        //                         }else{
                        setBookingStep(decrementStep);
                        // }
                    }}
                    showMenu={false}
                    width={width}
                    alertMessage={alertMessage}
                    alertType={alertType}
                />
                <div className="container mb-150">
                    <div className={`max-w-50-vw centered ${width > 800 ? `${bookingStep === 0 ? "pt-80" : "pt-24"} pb-80` : 'mb-150'}`}>
                        {loading ? <div className="text-center">
                            <CircularProgress sx={{ color: '#586B94' }} />
                        </div> : this.showRelevantStep()}
                    </div>
                </div>
            </div>
        </>
        );
    }
}
const mapStateToProps = (state) => ({
    ...state.booking,
    loading: state.loading.loading,
});
export default connect(mapStateToProps, { setBookingStep, setDataByStep, setLoading })(Index);